import { Canvas } from "@react-three/fiber";
import { createPortal } from "react-dom";
import {
  Stats,
  OrbitControls,
  Environment,
  useGLTF,
  PerspectiveCamera,
  Html,
} from "@react-three/drei";
import { useControls } from "leva";
import { Suspense, useState } from "react";
import Floor from "./Floor";
import TabBar from "./TabBar";
import Loader from "./Loader";
import Lighting from "./Lighting";

const Models = [
  { title: "Ford Bronco", url: "./models/bronco.glb", scale: 0.5 },
  {
    title: "Range Rover Sport SVR",
    url: "./models/rrsport.glb",
    scale: 0.02,
    position: [0, 0.9, 0],
  },
  {
    title: " Yamaha YZF R3 2017",
    url: "./models/yamahar3.glb",
    scale: 0.3,
    position: [0, 0.9, 0],
  },
  { title: "Honda Shadow RS 2010", url: "./models/hondashrs.glb", scale: 1.2 },
  { title: "Mclaren 720s 2017", url: "./models/mclaren.glb", scale: 1.2 },
  {
    title: " Porsche Carrera GT 2003",
    url: "./models/carrera.glb",
    scale: 1.2,
  },
  { title: "Toyota 4Runner", url: "./models/4Run.glb", scale: 0.7 },
  { title: "Toyota Supra MK4 1997", url: "./models/supra.glb" },
];

function Model({ url }) {
  const { scene } = useGLTF(url);
  console.log(url, scene);
  scene.visible = true;
  return <primitive object={scene} />;
}

export default function App() {
  const [selectedModel, setSelectedModel] = useState(Models[0]);

  return (
    <>
      <TabBar models={Models} onClick={setSelectedModel} />
      <Canvas shadows>
        <OrbitControls
          autoRotate
          autoRotateSpeed={0.5}
          maxPolarAngle={Math.PI / 2 - Math.PI / 20}
          maxZoom={8}
        />
        <PerspectiveCamera makeDefault fov={50} position={[0, 0, 6]} />
        <color args={[0, 0, 0]} attach="background" />
        <Lighting />
        {/* <Loader /> */}
        <group
          scale={selectedModel.scale || 1}
          position={selectedModel.position || [0, 0, 0]}
        >
          <Suspense fallback={<Loader />}>
            <Model url={selectedModel.url} />
          </Suspense>
        </group>

        <Floor />
        {/* <Stats /> */}
      </Canvas>
    </>
  );
}
